import { render, staticRenderFns } from "./ColorsPicker.vue?vue&type=template&id=fb6c3114&scoped=true"
import script from "./ColorsPicker.vue?vue&type=script&lang=js"
export * from "./ColorsPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorsPicker.vue?vue&type=style&index=0&id=fb6c3114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6c3114",
  null
  
)

export default component.exports